<template>
  <div id="m-oidcCallback">
    <LoadingSpinner :isLoading="true" />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

  export default {
    name: 'OidcCallback',
    computed: {
      ...mapGetters('oidcStore', ['oidcIsAuthenticated'])
    },
    methods: {
      ...mapActions('oidcStore', ['oidcSignInCallback'])
    },
    created() {
      if (this.oidcIsAuthenticated) {
        this.$router.go(1);
      } else {
        this.oidcSignInCallback()
          .then((redirectPath) => {
            if (redirectPath === 'undefined') {
              redirectPath = '/';
            }
            this.$router.push(redirectPath);
          })
          .catch((err) => {
            this.$router.push('/oidc-callback-error');
          });
      }
    },
    components: {
      LoadingSpinner
    }
  };
</script>
